import defineComponent from 'flight';
import Spinner from 'static/script/libs/spin';

function KlarnaPin() {

    this.defaultAttrs({
        pinCode: '[data-klarna-pin-code]',
        submitButton: '[data-klarna-pin-submit-button]',
        submitButtonText: '[data-klarna-signup-submit-button-text]',
        cancelButton: '[data-klarna-pin-cancel-button]',
        input: 'input',
        pincodeRequiredValidationMessage: '[data-klarna-pin-required-validation-message]',
        serverSideErrorPinCode: '[data-klarna-pin-server-side-error-pincode]',
        serverSideErrorExceededAttempts: '[data-klarna-pin-server-side-error-exhausted-attempts]',
        serverSideErrorUnhandled: '[data-klarna-pin-server-side-error-unhandled]'
    });

    this._onSubmitClick = function () {

        this.submitClicked = true;
        this._hideServerSideError();

        let validationResult = this._validateInputs();
        if (!validationResult.isFormValid) {
            return;
        }


        if (this.isSubmitting) {
            return;
        }

        let payload = {
            pinCode: this.select('pinCode').val()
        };

        this.isSubmitting = true;

        this.trigger(document, 'ui:klarna-pin:submit', payload);

        this._delaySubmitSpinner();
    };

    this._delaySubmitSpinner = function () {
        this.timeout = setTimeout(function () {
            this._enableSubmitSpinner();
        }.bind(this), 100);
    };

    this._enableSubmitSpinner = function () {
        this._initSpinner();
        this.spinner.spin();
        let buttonHeight = this.select('submitButton').height();
        this.select('submitButtonText').hide();
        this.select('submitButton').append(this.spinner.el);
        this.select('submitButton').height(buttonHeight);
    };

    this._disableSubmitSpinner = function () {
        if (this.spinner) {
            this.spinner.stop();
        }
        this.select('submitButtonText').show();
    };

    this._showServerSideError = function (data) {
        if (data.invalidPin) {
            this.select('serverSideErrorPinCode').show();
        } else if (data.exhaustedAttempts) {
            this.select('serverSideErrorExceededAttempts').show();
        } else {
            this._showUnhandledServerSideError();
        }
    };

    this._showUnhandledServerSideError = function () {
        this.select('serverSideErrorUnhandled').show();
    };

    this._hideServerSideError = function () {
        this.select('serverSideErrorPinCode').hide();
        this.select('serverSideErrorExceededAttempts').hide();
        this.select('serverSideErrorUnhandled').hide();
    };

    this._onCancelClick = function () {

    };

    this._afterSubmit = function (evt, data) {
        this.isSubmitting = false;
        if (data.ok) {
            this.trigger(document, 'ui:navigate', { href: '/my/klarna-pin/success' });
        }
        else if (data.userCanResolveError) {
            this._showServerSideError(data);
            this._disableSubmitSpinner();
        }
        else {
            this._showUnhandledServerSideError();
            this._disableSubmitSpinner();
        }
    };

    this._onSubmitError = function () {
        this.isSubmitting = false;
        this._disableSubmitSpinner();
    };

    this._initSpinner = function () {
        if (this.spinner) {
            return;
        }
        let options = {
            lines: 9,
            length: 5,
            width: 4,
            radius: 5,
            corners: 1,
            rotate: 0,
            direction: 1,
            color: '#fff',
            position: 'relative'
        };
        this.spinner = new Spinner(options);
    };

    this._onInputChange = function () {
        this._validateInputs();
    };

    this._validateFieldRequired = function (name) {
        let val = this.select(name).val();
        return val.trim() !== '';
    };

    this._validatepincode = function () {
        this._visible('pincodeRequiredValidationMessage', false);

        if (!this._validateFieldRequired('pinCode')) {
            if (this.submitClicked) {
                this._visible('pincodeRequiredValidationMessage', true);
            }
            return false;
        }

        return true;
    };

    this._validateInputs = function () {
        let ispincodeValid = this._validatepincode();
        return {
            ispincodeValid: ispincodeValid,
            isFormValid: ispincodeValid
        };
    };

    this._visible = function (selector, visible) {
        if (visible) {
            this.select(selector).show();
        } else {
            this.select(selector).hide();
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            submitButton: this._onSubmitClick,
            cancelButton: this._onCancelClick
        });

        this.on('change', { input: this._onInputChange });
        this.on('keyup', { input: this._onInputChange });

        this.on(document, 'data:klarna-pin:after-submit', this._afterSubmit);
        this.on(document, 'data:klarna-pin:on-submit-error', this._onSubmitError);
    });
}

module.exports = defineComponent.component(KlarnaPin);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/klarna-pin-ui.js